(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delivery-estimate')) {
    class DeliveryEstimate extends HTMLElement {
      connectedCallback() {
        const minDays = Number.parseInt(this.dataset.minDays, 10);
        const maxDays = Number.parseInt(this.dataset.maxDays, 10);
        if (!Number.isFinite(minDays) || !Number.isFinite(maxDays)) return;

        const start = Math.min(minDays, maxDays);
        const end = Math.max(minDays, maxDays);
        const formatter = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
        const minText = formatter.format(addBusinessDays(new Date(), start));
        const maxText = formatter.format(addBusinessDays(new Date(), end));
        const range = minText === maxText ? minText : `${minText}\u2013${maxText}`;
        const dates = this.querySelector('[data-delivery-dates]');
        if (dates) dates.textContent = range;
      }
    }

    function addBusinessDays(from, businessDays) {
      const date = new Date(from.getFullYear(), from.getMonth(), from.getDate());
      let remaining = businessDays;
      if (remaining <= 0) return date;
      while (remaining > 0) {
        date.setDate(date.getDate() + 1);
        const day = date.getDay();
        if (day !== 0 && day !== 6) remaining -= 1;
      }
      return date;
    }

    customElements.define('delivery-estimate', DeliveryEstimate);
  }
  } catch(e) { console.error(e); }
})();

})();
